import { FileModel } from '../typescript-angular-client/model/fileModel';
import { TreeNode } from 'primeng/api';

export function IsTreeNode(model: FileModel | TreeNode | FileModel[]): model is TreeNode {
  return (<TreeNode>model).key !== undefined;
}

export function IsSingleFileModel(model: FileModel | FileModel[] | TreeNode): model is FileModel {
  return (<FileModel>model).Id !== undefined;
}

export function IsMultiFileModel(model: FileModel | FileModel[] | TreeNode): model is FileModel[] {
  return (<FileModel[]>model).length !== undefined;
}
